import { Component } from '@angular/core';
import { UUID } from '@finxone-platform/shared/base-types';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ActiveConfigService } from '../../../libs/services/active-config/active-config.service';
import { ProjectsState } from '../../../libs/state/project.state';

@Component({
  standalone: false,
  selector: 'finxone-workflow-frontend-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Select(ProjectsState.getActiveProject)
  activeProject$!: Observable<{
    id: UUID;
    name: string;
  }>;
  constructor(public activeConfigService: ActiveConfigService) {}
}
